module.exports = __webpack_public_path__ + "ai-bot-borderwp45d564d91af88da5a2aa1c4ee7661603.png";